import React, { useContext } from 'react';

import { Alert } from '../../../../components/ui/Alert';
import { MlifeAccountSetupContext } from '../MlifeAccountSetupContext';

export function ErrorSection() {
  const { accountSetupError } = useContext(MlifeAccountSetupContext);

  if (!accountSetupError) return null;
  return <Alert text={accountSetupError} />;
}

ErrorSection.displayName = 'ErrorSection';
